import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagHivVulnerability = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "current",
		children: [/* @__PURE__ */ _jsx("path", { d: "m9.81465 12.4554-3.76194 5.5446-1.05271-2.7358 3.1422-4.6504.47205-.6138.41703.631.79496 1.2463.17376.2762z" }), /* @__PURE__ */ _jsx("path", { d: "m13.9829 17.9986 1.0129-2.547c.0069-.0177.0055-.0367-.0055-.053-.4145-.6038-6.6442-10.02365-6.78145-11.17955.2594-.23525.74389-.66633 1.92975-.66633.8248 0 1.4383.2067 1.7485.41476.1963.13191.2828.37532.21.5997-.2223.68538-1.1831 2.37842-1.7087 3.14947l1.286 2.02893s1.7581-2.5756 1.7581-4.16121-1.3217-3.18074-2.0038-3.41464-2.36068-.31957-2.95634.37124c-.72467.8404-1.52209 2.05477-1.46993 3.01756.05215.96279.31567 2.26283 1.3121 3.66757.9978 1.4048 5.66837 8.7739 5.66837 8.7739z" })]
	})
});
export default SvgFlagHivVulnerability;
